import { useLoadScript } from '@react-google-maps/api'
import React from 'react'
import { getConfig } from '../src/utils/config'

const libraries = ['places']
export const MapContainer: React.FunctionComponent = ({ children }) => {
	const apikey = getConfig('googleMapsApikey');

	const { isLoaded } = useLoadScript({
		googleMapsApiKey: apikey.googleMapsApikey,
		libraries: libraries as any,
	})

	if (!isLoaded) {
		return null
	}

	return <>{children}</>
}
